import { Icon } from '@natera/material/lib/icon'
import { xor } from 'lodash-es'
import { cn } from '~/shared/lib/cn'
import { Text } from '~/shared/ui'
import type { PinnableConsignmentFilterKey } from '../../../model'
import { usePinnedFilters } from '../../../model'

export function ExpansionPanelLabel({
  filterKey,
  label,
  disabled = false,
}: {
  filterKey: PinnableConsignmentFilterKey
  label: string
  disabled?: boolean
}) {
  const { pinnedFilters, setPinnedFilters } = usePinnedFilters()

  return (
    <div className="-ml-0.5 flex items-center gap-[11px]">
      <button
        type="button"
        className={cn(
          'cursor-pointer border-none bg-transparent p-0',
          disabled && 'pointer-events-none opacity-50',
        )}
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
          setPinnedFilters(xor(pinnedFilters, [filterKey]))
        }}
      >
        <Icon
          className="text-primary-main text-[20px]"
          children="keep"
          fill={pinnedFilters.includes(filterKey) ? true : false}
        />
      </button>
      <Text appearance="SUBTITLE2">{label}</Text>
    </div>
  )
}
